<template>
    <div class="page-container" :class="{ collapsed: !$store.getters.sidebarOpened }">
        <div class="area-container left-area">
            <CommonTree
                ref="faculty_tree"
                type="room"
                :showFilter="true"
                @change="handleNodeClick"
                :customStyle="{ height: 'calc(100vh - 158px)', borderRight: 'none', width: '100%' }"
            />
        </div>
        <div class="data-container center-area">
            <!-- 标签页：日流水 / 月流水 -->
            <el-tabs v-model="activeTab" type="card" style="margin-bottom: 16px">
                <el-tab-pane label="日流水" name="day"></el-tab-pane>
                <el-tab-pane label="月流水" name="month"></el-tab-pane>
            </el-tabs>

            <div class="tool-box">
                <div style="width: 400px">
                    <el-date-picker
                        v-model="dateRange"
                        :type="activeTab === 'day' ? 'daterange' : 'monthrange'"
                        :start-placeholder="activeTab === 'day' ? '开始日期' : '开始月份'"
                        :end-placeholder="activeTab === 'day' ? '结束日期' : '结束月份'"
                        :format="activeTab === 'day' ? 'YYYY-MM-DD' : 'YYYY-MM'"
                        :value-format="activeTab === 'day' ? 'YYYY-MM-DD' : 'YYYY-MM'"
                        style="margin-right: 12px"
                        @change="handleDateChange"
                    />
                </div>
                <el-button type="primary" :icon="Refresh" @click="resetQueryForm" style="margin-left: right">刷新</el-button>
                <el-button type="primary" :icon="UploadFilled" plain @click="onAddClick">导出</el-button>
            </div>
            <el-table
                class="data-table"
                :data="table_data"
                v-loading="tableLoading"
                @selection-change="handleSelectionChange"
                scrollbar-always-on
            >
                <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>

                <el-table-column label="位置" prop="location" align="center" min-width="280" show-overflow-tooltip>
                    <template #default="{ row }">
                        {{ row.location || '-' }}
                    </template>
                </el-table-column>

                <el-table-column
                    v-if="activeTab === 'day'"
                    label="计费日期"
                    prop="billing_date"
                    align="center"
                    min-width="120"
                ></el-table-column>
                <el-table-column v-else label="计费日期" prop="billing_month" align="center" min-width="120"></el-table-column>

                <el-table-column
                    label="温控器IMEI"
                    prop="thermostat_imei"
                    align="center"
                    min-width="180"
                    show-overflow-tooltip
                ></el-table-column>

                <el-table-column label="运行时单价" prop="unit_price" align="center" min-width="130">
                    <template #default="{ row }">
                        {{ row.unit_price ? row.unit_price + ' 元/小时' : '-' }}
                    </template>
                </el-table-column>

                <el-table-column label="中功率单价" prop="unit_price_mid" align="center" min-width="130">
                    <template #default="{ row }">
                        {{ row.unit_price_mid ? row.unit_price_mid + ' 元/小时' : '-' }}
                    </template>
                </el-table-column>

                <el-table-column label="低功率单价" prop="unit_price_low" align="center" min-width="130">
                    <template #default="{ row }">
                        {{ row.unit_price_low ? row.unit_price_low + ' 元/小时' : '-' }}
                    </template>
                </el-table-column>

                <el-table-column label="高功率时长" prop="high_time" align="center" min-width="120">
                    <template #default="{ row }">
                        {{ row.high_time ? row.high_time + ' 分钟' : '-' }}
                    </template>
                </el-table-column>

                <el-table-column label="中功率时长" prop="mid_time" align="center" min-width="120">
                    <template #default="{ row }">
                        {{ row.mid_time ? row.mid_time + ' 分钟' : '-' }}
                    </template>
                </el-table-column>

                <el-table-column label="低功率时长" prop="low_time" align="center" min-width="120">
                    <template #default="{ row }">
                        {{ row.low_time ? row.low_time + ' 分钟' : '-' }}
                    </template>
                </el-table-column>

                <el-table-column label="计费金额" prop="fee" align="center" min-width="120" fixed="right">
                    <template #header="scope">
                        <div style="display: flex; align-items: center">
                            计费金额
                            <el-tooltip effect="dark" placement="left" :enterable="false" :show-after="500">
                                <template #content>
                                    高功率时长 / 60 * 运行时单价 + 中功率时长 / 60 * 中功率单价 + 低功率时长 / 60 * 低功率单价
                                    <br />
                                    每个月1号加基础费用
                                </template>
                                <el-icon style="margin-left: 5px"><InfoFilled /></el-icon>
                            </el-tooltip>
                        </div>
                    </template>
                    <template #default="{ row }">
                        <span style="color: #f56c6c; font-weight: bold">
                            {{ row.fee ? row.fee + ' 元' : '-' }}
                        </span>
                    </template>
                </el-table-column>

                <el-table-column label="起始时间" prop="start_time" align="center" min-width="170"></el-table-column>

                <el-table-column label="截止时间" prop="end_time" align="center" min-width="170"></el-table-column>
            </el-table>

            <!-- 合计统计区域 -->
            <div v-if="table_data.length > 0" class="summary-bar">
                <div class="summary-item">
                    <span class="summary-label">高功率时长合计：</span>
                    <span class="summary-value">{{ summaryData.high_time }} 分钟</span>
                </div>
                <div class="summary-item">
                    <span class="summary-label">中功率时长合计：</span>
                    <span class="summary-value">{{ summaryData.mid_time }} 分钟</span>
                </div>
                <div class="summary-item">
                    <span class="summary-label">低功率时长合计：</span>
                    <span class="summary-value">{{ summaryData.low_time }} 分钟</span>
                </div>
                <div class="summary-item">
                    <span class="summary-label">计费金额合计：</span>
                    <span class="summary-value highlight">{{ summaryData.fee }} 元</span>
                </div>
            </div>

            <Pagination
                v-if="table_data.length > 0"
                :current-page="page_params.page"
                :page-size="page_params.page_size"
                :total="total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
            />
        </div>
    </div>
</template>

<script setup>
import { onMounted, reactive, ref, watch, computed } from 'vue'
import { Delete, Edit, Plus, Refresh, InfoFilled, Upload, UploadFilled } from '@element-plus/icons'
import { getBillingRecordList, getBillingMonthRecordList } from '@/api/thermostat/billing.js'
import { ElLoading, ElMessage, ElMessageBox } from 'element-plus'
import Pagination from '@/components/Pagination/index.vue'
import CommonTree from '@/components/BuildTree/CommonTree.vue'
import Exceljs from 'exceljs'
import FileSaver from 'file-saver'

// 标签页激活项
const activeTab = ref('day')

// 日期范围
const dateRange = ref([])

// 计费方式映射
const methodMap = {
    1: { name: '热量表', type: 'success' },
    2: { name: '热量表+温控器', type: 'warning' },
    3: { name: '温控器', type: 'primary' }
}

// 左侧区域树
const faculty_tree = ref(null)
const current_node = ref({})

const handleNodeClick = (data) => {
    current_node.value = data
    resetQueryForm()
}

// 日期变化
const handleDateChange = () => {
    page_params.page = 1
    getTableData()
}

// 重置查询（页码归1 + 刷新数据）
const resetQueryForm = () => {
    page_params.page = 1
    getTableData()
}

const table_data = ref([])
const tableLoading = ref(true)
const total = ref(0)

// 计算合计数据
const summaryData = computed(() => {
    const data = table_data.value
    const high_time = data.reduce((sum, item) => sum + (Number(item.high_time) || 0), 0)
    const mid_time = data.reduce((sum, item) => sum + (Number(item.mid_time) || 0), 0)
    const low_time = data.reduce((sum, item) => sum + (Number(item.low_time) || 0), 0)
    const fee = data.reduce((sum, item) => sum + (Number(item.fee) || 0), 0)
    return {
        high_time,
        mid_time,
        low_time,
        fee: fee.toFixed(2)
    }
})

// 获取列表数据：根据标签切换 日/月 接口
async function getTableData() {
    tableLoading.value = true
    const params = {
        ...page_params,
        building: current_node.value?.room_type ? '' : current_node.value?.id,
        room: current_node.value?.room_type ? current_node.value.id : ''
    }

    // 添加时间范围参数
    if (dateRange.value && dateRange.value.length === 2) {
        params.start_time = dateRange.value[0]
        params.end_time = dateRange.value[1]
    }

    try {
        // 日流水 / 月流水 区分接口
        const apiFn = activeTab.value === 'day' ? getBillingRecordList : getBillingMonthRecordList
        const res = await apiFn(params)

        table_data.value = (res?.lists || []).map((item) => ({
            ...item,
            method_name: methodMap[item.method]?.name || item.method,
            heat_meter_name: item.heat_meter_name || item.heat_meter || '-',
            thermostat_name: item.thermostat_name || item.thermostat || '-'
        }))
        total.value = res?.total || 0
    } catch (err) {
        console.log(err)
    } finally {
        tableLoading.value = false
    }
}

// 监听标签切换，自动重置并刷新
watch(activeTab, () => {
    dateRange.value = [] // 切换标签时清空日期
    resetQueryForm()
})

// 分页相关
const page_params = reactive({
    page: 1,
    page_size: 10
})
const handleSizeChange = (currentSize) => {
    page_params.page_size = currentSize
    page_params.page = 1
    getTableData()
}
const handleCurrentChange = (currentPage) => {
    page_params.page = currentPage
    getTableData()
}

// 表格多选
const selected_ids = ref([])
function handleSelectionChange(list) {
    selected_ids.value = list.map((item) => item.id)
}

const feePlanRef = ref(null)

// 编辑
const onEditClick = (row) => {
    feePlanRef.value.open(row)
}

// 删除
function onRemoveClick(building) {
    if (!building) {
        ElMessage.error('缺少小区ID，无法删除')
        return
    }
    ElMessageBox.confirm('是否确认删除该计费方式？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
    })
        .then(() => {
            deleteBilling(building)
                .then(() => {
                    ElMessage.success('删除成功')
                    getTableData()
                })
                .catch((err) => {
                    console.log(err)
                    ElMessage.error('删除失败')
                })
        })
        .catch(() => {})
}
const onAddClick = () => {
    ElMessageBox.confirm('确定要导出账单吗？', '提示', {
        type: 'warning'
    })
        .then(async () => {
            const loading = ElLoading.service({
                lock: true,
                text: '正在导出...',
                spinner: 'Loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })

            try {
                let list = []

                const apiFn = activeTab.value === 'day' ? getBillingRecordList : getBillingMonthRecordList
                await apiFn({
                    page_size: -1
                }).then((data) => {
                    console.log('🚀 ~ onAddClick ~ data:', data)
                    list = data.lists
                })
                if (list.length <= 0) {
                    return ElMessage.error('没有数据可导出')
                }
                console.log('🚀 ~ onAddClick ~ list:', list)
                // 创建excel并写入数据
                let workbook = null
                workbook = new Exceljs.Workbook()
                workbook.created = new Date()
                workbook.modified = new Date()
                workbook.lastPrinted = new Date()
                const worksheet = workbook.addWorksheet('账单流水', {
                    properties: {
                        defaultRowHeight: 22
                    },
                    pageSetup: {
                        horizontalCentered: true
                    }
                })

                console.log('🚀 ~ onAddClick ~ worksheet:', worksheet)
                worksheet.columns = [
                    {
                        header: '序号',
                        key: 'index',
                        width: 10
                    },
                    {
                        header: '位置',
                        key: 'location',
                        width: 50
                    },
                    {
                        header: '计费日期',
                        key: activeTab.value === 'day' ? 'billing_date' : 'billing_month',
                        width: 30
                    },
                    {
                        header: '温控器IMEI',
                        key: 'thermostat_imei',
                        width: 20
                    },
                    {
                        header: '运行时单价',
                        key: 'unit_price',
                        width: 10
                    },
                    {
                        header: '中功率单价',
                        key: 'unit_price_mid',
                        width: 10
                    },
                    {
                        header: '低功率单价',
                        key: 'unit_price_low',
                        width: 10
                    },
                    {
                        header: '高功率时长',
                        key: 'high_time',
                        width: 20
                    },
                    {
                        header: '中功率时长',
                        key: 'mid_time',
                        width: 20
                    },
                    {
                        header: '低功率时长',
                        key: 'low_time',
                        width: 20
                    },
                    {
                        header: '起始时间',
                        key: 'start_time',
                        width: 20
                    },
                    {
                        header: '截止时间',
                        key: 'end_time',
                        width: 20
                    },
                    {
                        header: '计费金额',
                        key: 'fee',
                        width: 22
                    }
                ]

                worksheet.addRows(
                    list.map((item, index) => {
                        return {
                            index: index + 1,
                            location: Array.isArray(item.location) ? item.location.join('/') : item.location || '',
                            billing_date: activeTab.value === 'day' ? item.billing_date : item.billing_month,
                            thermostat_imei: item.thermostat_imei,
                            unit_price: item.unit_price + '元/小时',
                            unit_price_mid: item.unit_price_mid,
                            unit_price_low: item.unit_price_low,
                            high_time: item.high_time + '分钟',
                            mid_time: item.mid_time + '分钟',
                            low_time: item.low_time + '分钟',
                            start_time: item.start_time,
                            end_time: item.end_time,
                            fee: item.fee + '元'
                        }
                    })
                )

                worksheet.getRow(1).alignment = {
                    horizontal: 'center',
                    vertical: 'middle'
                }

                // 导出excel文件
                await workbook.xlsx.writeBuffer().then((buffer) => {
                    const date = new Date()
                    const year = date.getFullYear() // 年
                    let month = date.getMonth() + 1 // 月
                    let day = date.getDate() // 日
                    let hour = date.getHours() // 时
                    let minutes = date.getMinutes() // 分
                    let seconds = date.getSeconds() // 秒
                    // 给一位数的数据前面加 “0”
                    if (month >= 1 && month <= 9) month = '0' + month
                    if (day >= 0 && day <= 9) day = '0' + day
                    if (hour >= 0 && hour <= 9) hour = '0' + hour
                    if (minutes >= 0 && minutes <= 9) minutes = '0' + minutes
                    if (seconds >= 0 && seconds <= 9) seconds = '0' + seconds
                    const presentDate = `${
                        activeTab.value === 'day' ? '日' : '月'
                    }流水账单${year}${month}${day}${hour}${minutes}${seconds}`

                    // 导出并存储文件
                    FileSaver.saveAs(new Blob([buffer]), `${presentDate}.xlsx`)
                    console.log('🚀 ~ onAddClick ~ presentDate:', presentDate)
                })
            } catch (err) {
                console.error('🚀 ~ onAddClick ~ error:', err)
                ElMessage.error('导出失败：' + (err?.message || err))
            } finally {
                loading.close()
            }
        })
        .catch(() => {})
}

onMounted(() => {
    getTableData()
})
</script>

<style scoped>
.page-container {
    display: flex;
    height: 100%;
}
.area-container {
    flex-shrink: 0;
}
.left-area {
    width: 260px;
    border-right: 1px solid #e4e7ed;
}
.center-area {
    flex: 1;
    padding: 16px;
    overflow: auto;
}
.tool-box {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
}
.data-table {
    margin-bottom: 0;
}

/* 合计统计栏 */
.summary-bar {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 32px;
    padding: 12px 16px;
    /* background-color: #f5f7fa; */
    /* border: 1px solid #e4e7ed; */
    border-top: none;
    /* border-radius: 0 0 4px 4px; */
    margin-bottom: 16px;
}
.summary-item {
    display: flex;
    align-items: center;
    font-size: 14px;
}
.summary-label {
    color: #606266;
}
.summary-value {
    color: #303133;
    font-weight: bold;
}
.summary-value.highlight {
    color: #f56c6c;
    font-size: 16px;
}
</style>
